import React, { useContext, useEffect, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_POSITIONS, UPDATE_POSITIONS } from "../../Schema/Positions";

export default function PositionsForm({ open, handleClose, setRefetch, title, editData }) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createPosition] = useMutation(CREATE_POSITIONS, {
    onCompleted: ({ createPosition }) => {
      setLoading(false);
      // console.log("createPosition::", createPosition);
      if (createPosition?.status === true) {
        setAlert(true, "success", createPosition?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createPosition?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const [updatePosition] = useMutation(UPDATE_POSITIONS, {
    onCompleted: ({ updatePosition }) => {
      setLoading(false);
      // console.log("updatePosition::", updatePosition);
      if (updatePosition?.status === true) {
        setAlert(true, "success", updatePosition?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", updatePosition?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    title: Yup.string().required("ទាមទារ!"),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("values:::", values);
      setLoading(true);
      if (title === "Create") {
        createPosition({
          variables: {
            title: values?.title,
          },
        });
      } else {
        // console.log("values:::", values?.title);
        updatePosition({
          variables: {
            id: editData?._id,
            title: values?.title,
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    getFieldProps,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("title", editData?.title)
    }
  }, [editData?.title])

  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">{title === "Create" ? "បង្កើត" : "កែប្រែ"}តួនាទី</Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={1.5} columnSpacing={3}>
              <Grid item xs={12}>
                <Typography className="field-title">
                  ឈ្មោះតួនាទី
                </Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ឈ្មោះតួនាទី"
                  {...getFieldProps("title")}
                  error={Boolean(
                    touched.title && errors.title
                  )}
                  helperText={touched.title && errors.title}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {title === "Create" ? "បង្កើត" : "កែប្រែ"}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
